module.exports = __webpack_public_path__ + "static/media/A5-landscape-v2.b587fb67.png";